import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '..'

const LoansCategories = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M17.5 11H15l-1-8a9.25 9.25 0 0 1 6 0c-1 3.5-1.5 5-2.5 8Z"
      fill="#8FBEFF"
    />
    <Path
      d="m18 9.494-.5 1.5H15l-1-8a9.28 9.28 0 0 1 3-.5h.125l.875 7Z"
      fill="#467AC2"
    />
    <Path
      d="M10.5 11H13l1-8a9.25 9.25 0 0 0-6 0c1 3.5 1.5 5 2.5 8Z"
      fill="#8FBEFF"
    />
    <Path
      d="M11.5 9c-.83-2.5-1.315-3.95-2.03-6.37-.5.082-.991.206-1.47.37 1 3.5 1.5 5 2.5 8H13l.25-2H11.5Z"
      fill="#467AC2"
    />
    <Path d="M16 8.5h-4l-1-8a9.25 9.25 0 0 1 6 0l-1 8Z" fill="#8FBEFF" />
    <Path
      d="M14.385 6a1 1 0 0 1-1-.875L12.76.085A9.56 9.56 0 0 0 11 .5l1 8h4c.105-.836.21-1.666.31-2.5h-1.925Z"
      fill="#467AC2"
    />
    <Path
      d="M24 21.748c0 5.5-4.5 5.25-10 5.25s-10 .25-10-5.25S8.5 8.5 14 8.5s10 7.75 10 13.25Z"
      fill="#8FBEFF"
    />
    <Path
      d="M23.74 23.748c-1.03 3.45-4.995 3.25-9.74 3.25-5.5 0-10 .25-10-5.25 0-4.77 3.33-11.174 7.8-12.839C9.5 11.654 8 15.564 8 18.75c0 5.5 4.5 5.25 10 5.25a37.119 37.119 0 0 0 5.74-.25Z"
      fill="#467AC2"
    />
    <Path d="M18 7.5h-8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2Z" fill="#F2E6C7" />
    <Path
      d="M11 7.5h-1a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1h-7a1 1 0 0 1-1-1Z"
      fill="#E2CA96"
    />
    <G clipPath="url(#a)">
      <Path
        d="M18.563 18.53a4.531 4.531 0 1 1-9.063 0 4.531 4.531 0 0 1 9.063 0Z"
        fill="#F0CD00"
      />
      <Path
        d="M18.563 18.53a4.53 4.53 0 0 1-4.363 4.527 4.53 4.53 0 0 1 0-9.055 4.53 4.53 0 0 1 4.363 4.528Z"
        fill="#FFDE50"
      />
      <Path
        d="M17.552 18.53a3.52 3.52 0 0 1-7.041.043v-.043a3.521 3.521 0 0 1 7.041 0Z"
        fill="#EAB540"
      />
      <Path
        d="m16.52 16.04-4.979 4.98a3.538 3.538 0 0 1-.786-1.198 3.506 3.506 0 0 1-.245-1.249v-.043a3.521 3.521 0 0 1 6.01-2.49Z"
        fill="#EAB540"
      />
      <Path
        d="M17.552 18.53a3.521 3.521 0 0 1-3.72 3.515 3.521 3.521 0 0 0 0-7.03 3.521 3.521 0 0 1 3.72 3.515Z"
        fill="#F68E00"
      />
      <Path
        d="M15.43 17.452h-.617a1.49 1.49 0 0 0-.16-.388h.777a.37.37 0 1 0 0-.74h-3.495a.37.37 0 0 0 0 .74h1.428c.283 0 .53.157.66.388h-2.088a.37.37 0 0 0 0 .74h2.088a.757.757 0 0 1-.66.386h-1.428a.37.37 0 0 0-.269.624l2.012 2.135a.369.369 0 0 0 .523.016.37.37 0 0 0 .015-.523l-1.424-1.512h.571a1.5 1.5 0 0 0 1.45-1.127h.617a.37.37 0 1 0 0-.74Z"
        fill="#F68E00"
      />
      <Path
        d="M15.893 17.452h-.617a1.487 1.487 0 0 0-.16-.388h.777a.37.37 0 1 0 0-.74h-3.495a.37.37 0 1 0 0 .74h1.428c.283 0 .53.157.66.388h-2.088a.37.37 0 1 0 0 .74h2.088a.757.757 0 0 1-.66.386h-1.428a.37.37 0 0 0-.27.624l2.012 2.135a.369.369 0 0 0 .523.016.37.37 0 0 0 .016-.523l-1.424-1.512h.57a1.5 1.5 0 0 0 1.451-1.127h.617a.37.37 0 1 0 0-.74Z"
        fill="#FFEA94"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill="#fff"
          transform="translate(9.5 13.999)"
          d="M0 0h9.063v9.062H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LoansCategories
